import { Delete } from "@mui/icons-material";
import { ReactElement } from "react";

import { ListStaffEmailsQuery } from "~frontend/__generated__/graphql";
import Table from "~frontend/components/Table";

export default function StaffEmailTable({
  rows,
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  totalCount,
  handleRemoveStaffEmail,
}: {
  rows: ListStaffEmailsQuery["listStaffEmails"];
  page: number;
  handleChangePage: (newPage: number) => void;
  rowsPerPage: number;
  handleChangeRowsPerPage: (newRowsPerPage: number) => void;
  totalCount: number;
  handleRemoveStaffEmail: (email: string) => Promise<void>;
}): ReactElement {
  return (
    <Table
      columns={[
        {
          key: "email",
          title: "Email",
          renderValue: staffEmail => (
            <span data-testid="staffemail-email-cell">{staffEmail.email}</span>
          ),
        },
        {
          key: "fullName",
          title: "Full Name",
          renderValue: staffEmail => (
            <span data-testid="staffemail-fullname-cell">
              {staffEmail.fullName}
            </span>
          ),
        },
        {
          key: "createdAt",
          title: "Added At",
          renderValue: staffEmail =>
            new Date(staffEmail.createdAt).toLocaleString(),
        },
      ]}
      rows={rows.map(staffEmail => ({ id: staffEmail.email, ...staffEmail }))}
      rowActions={[
        {
          id: "remove-staff-email",
          type: "button",
          icon: <Delete />,
          tooltipLabel: "Remove Staff Account",
          confirm: {
            title: "Remove Staff Account",
            content:
              "Are you sure you want to remove this staff account? This will also disable their account on all tenants.",
          },
          onClick: ({ id }) => handleRemoveStaffEmail(id),
        },
      ]}
      emptyState="No staff emails found"
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      page={page}
      onChangePage={handleChangePage}
    />
  );
}
